import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

export type ColumnNames = {[key: string]: ReactNode};

/*
 * Style.
 */

const StyledIconButton = styled(IconButton)`
  margin-left: 8px;
`;

/*
 * Props.
 */

type TableExportSelectorProps = {
  isLoading: boolean;
  clickHandler: () => void;
};

/*
 * Component.
 */

export const TableExportSelector: FC<TableExportSelectorProps> = ({clickHandler}) => {
  const theme = useUserTheme();

  return (
    <StyledIconButton
      iconName="export"
      label={<Trans id="analytics-table-export-button">Export as CSV</Trans>}
      color={theme.greys.shade70}
      onClick={clickHandler}
    />
  );
};
